import React from 'react'
import { shape, func } from 'prop-types'

class Variant extends React.Component {
  render() {
    const { children, variables } = this.props
    return children(variables)
  }
}

Variant.propTypes = {
  children: func.isRequired,
  variables: shape({})
}

Variant.defaultProps = {
  variables: {}
}

export default Variant
